// @ts-nocheck
/* eslint-disable */
export const attackIcon = {
  data: `<svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.94531 13.3424C11.8908 13.3424 14.2786 10.9546 14.2786 8.00912C14.2786 5.0636 11.8908 2.67578 8.94531 2.67578" stroke="currentColor" stroke-linecap="round"/><path d="M3.61197 8.00781H10.2786M10.2786 8.00781L8.27864 6.00781M10.2786 8.00781L8.27864 10.0078" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'attack' as const,
};
